import React, { useState } from 'react';
import { Modal, Button, Row, Col, ProgressBar } from 'react-bootstrap';
import EditIcon from '../assets/images/edit-1.svg';
import EditRedIcon from '../assets/images/edit-red.svg';
import EditWhiteIcon from '../assets/images/edit-white.svg';
import Currency from '../assets/images/currency.svg';
import Lightbulb from '../assets/images/lightbulb.svg';
import '../scss/buy-ability-result-modal.scss';

const BuyAbilityResultModal = ({ show, handleClose, handleEditInfo }) => {
  const [targetPrice] = useState(100000);
  const [maxPrice] = useState(100000);
  const [targetPayment] = useState(105);
  const [downPayment] = useState(100000);

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  };

  const handleSavePreferences = () => {
    console.log('Saving preferences...');
    handleClose();
  };

  return (
    <Modal 
      show={show} 
      onHide={handleClose}
      centered
      scrollable
      className="buy-ability-result-modal"
      size="lg"
    >
      <Modal.Header closeButton className="border-0">
        <div className="d-flex align-items-center justify-content-between w-100">
          <div className="link-icon"  onClick={handleEditInfo}>
           <img src={EditRedIcon} alt="" />
          </div>
          <Modal.Title>Your BuyAbility<sup>SM</sup></Modal.Title>
         
        </div>
      </Modal.Header>
      
      <Modal.Body>
        {/* Target Price Section */}
        <div className="target-price-section">
          <div className="label">Today's target price</div>
          <div className="price">{formatCurrency(targetPrice)}</div>
        </div>

        {/* Progress Bar */}
        <div className="price-range-section">
          <div className="progress-wrapper">
            <ProgressBar 
              now={(targetPrice / maxPrice) * 100} 
              className="custom-progress"
            />
          </div>
          <div className="range-labels">
            <span>$0k</span>
            <span>Max: {formatCurrency(maxPrice)}</span>
          </div>
        </div>
        <div className='payment-details-box'>
          {/* Info Message */}
          <div className="info-message">
            <div className="icon">
              <img src={Lightbulb} alt="" />
              </div>
            <p>
              You may qualify for a higher range. Increasing your down payment could get you there.
            </p>
          </div>

          {/* Payment Details */}
          <Row className="payment-details">
            <Col xs={12}>
              <div className="detail-item mb-3">
                <label>Target payment</label>
                <div className="value-with-icon">
                  <span className="icon">
                    <img src={Currency} alt="" />
                  </span>
                  <span className="value">{targetPayment}</span>
                  <span className="suffix">/ mo</span>
                </div>
              </div>
            </Col>
            <Col xs={12}>
              <div className="detail-item">
                <label>Down payment</label>
                <div className="value-with-icon">
                  <span className="icon">
                    <img src={Currency} alt="" />
                  </span>
                  <span className="value">{downPayment.toLocaleString()}</span>
                </div>
              </div>
            </Col>
          </Row>

          {/* Edit Button */}
          <Button 
            variant="outline-dark" 
            className="custom-bttn style-2 ani-1 w-100"
          
          >
            <img src={EditIcon} /> Edit Your Info
          </Button>
        </div>
        {/* What Real Estate Could Offer */}
        <div className="offer-section">
          <h5>What Real Estate could offer</h5>
          
          <div className="offer-details">
            <div className="offer-item">
              <span className="label">Max home price</span>
              <span className="value">{formatCurrency(maxPrice)}</span>
            </div>
            <div className="offer-item">
              <span className="label">Max payment</span>
              <span className="value">{formatCurrency(105)}/mo</span>
            </div>
            <hr />
            <div className="offer-item">
              <span className="label">Loan option</span>
              <span className="value">30 Year Fixed</span>
            </div>
            <div className="offer-item">
              <span className="label">Your est. interest rate</span>
              <span className="value">0.00%</span>
            </div>
            <div className="offer-item">
              <span className="label">APR</span>
              <span className="value">0.00%</span>
            </div>
            <div className="offer-item">
              <span className="label">Points</span>
              <span className="value">$0 (0 points)</span>
            </div>
          </div>

          {/* Get Pre-qualified Button */}
          <Button className="custom-bttn style-3 ani-1 w-100">
            <img src={EditWhiteIcon} alt='' />  Get Pre-qualified
          </Button>
        </div>

        {/* Save Preferences Button */}
         <p className="disclaimer">
            All calculations are estimates and provided by Real Estate, LLC for informational 
            purposes only. Actual amounts may vary.
          </p>
        <Button 
          className="custom-bttn style-3 w-100"
          onClick={handleSavePreferences}
        >
          Save Preferences
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default BuyAbilityResultModal;